import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Apple just doesn't get it anymore",
  "description": "",
  "published": "2012-10-24T00:00:00.000Z",
  "redirect_from": ["/blog/with-apple-gone-where-can-i-turn/swizec/5428"],
  "categories": "Apple, Aston Martin, Ferrari, Recreation, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Six years ago I bought my first `}<a parentName="p" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple`}</a>{` product - a MBP, the last version before unibody designs. The unboxing alone was enough to make me a fan.`}</p>
    <p>{`Apple was to other devices as `}<a parentName="p" {...{
        "href": "http://www.astonmartin.co.uk/",
        "title": "Aston Martin"
      }}>{`Aston Martin`}</a>{` is to other cars - classy, polished, perfect.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/2012-Aston-Martin-Vanquish-8.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/2012-Aston-Martin-Vanquish-8-1024x602.jpg",
          "alt": "2012 Aston Martin Vanquish",
          "title": "2012 Aston Martin Vanquish"
        }}></img></a></p>
    <p>{`Sure, it's not the most powerful car out there - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Bugatti_Veyron",
        "title": "Bugatti Veyron"
      }}>{`Veyron`}</a>{` does that, the equivalent of the bleeding edge gaming rig - it doesn't have the best cornering either, nor the best handling, best acceleration or a number of other things that are left for the Zondas, Lambos and Ferraris of the world.`}</p>
    <p>{`But that's a different playing field.`}</p>
    <p>{`While most other supercars are vulgar, tacky even, Aston Martin is exciting enough to make your heart stop, yet gorgeous. The first car maker to simply say `}<em parentName="p">{`"It's gorgeous! Don't you want it?".`}</em></p>
    <p><a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=_DEBo19wb8Y"
      }}>{`http://www.youtube.com/watch?v=`}{`_`}{`DEBo19wb8Y`}</a></p>
    <p>{`Aston Martin doesn't sell specs, they sell the experience. The only supercar with taste. Beautiful exciting perfection.`}</p>
    <p>{`Until recently Apple was just like that. They were the Aston Martin of the gadget world - more powerful than the cheap alternatives, but not really competing on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Instructions_per_second",
        "title": "Instructions per second"
      }}>{`CPU speed`}</a>{`, RAM size, screen size and so on. Pricier than most alternatives, a purchase you couldn't explain to many of your friends, but totally worth it.`}</p>
    <p>{`A perfect experience. Every time.`}</p>
    <p>{`The only laptop that doesn't creak when you grab it. The only laptop beautiful enough to act as the default movie laptop. The mp3 player with marketing of a simple silhouette. The phone that fits in your palm, looks stylish in every setting and never feels sluggish.`}</p>
    <p>{`Lately, though, Apple has become this.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/ricer_civic_2.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/ricer_civic_2.jpg",
          "alt": "Ricer Civic",
          "title": "Ricer Civic"
        }}></img></a></p>
    <p>{`A ricer car competing with their neighbourhood hooligans on how big their spoiler is, how low they can go, how wide are the rims and whether it's got 134 or 135 horsepowers.`}</p>
    <p>{`Apple just doesn't `}<em parentName="p">{`get it`}</em>{` anymore.`}</p>
    <p>{`At the end of the day, who really cares if their iPad mini is 5 or 7 millimetres thick? Or their iMac is 3 ounces heavier or lighter?`}</p>
    <p>{`Specs are easy to compete on. Incredibly so.`}</p>
    <p>{`See a competitor that's doing good? Just slap a bigger processor on your phone, make the screen 3 millimetres bigger and voila, the geek crowd is impressed! They will flock to your product and buy as many copies as they can. Simply because they can go to their friends in a bar and say `}<em parentName="p">{`Hey, you suck! My phone is three milliseconds faster than yours! HA!`}</em></p>
    <p>{`Really?`}</p>
    <p>{`Is this what Apple has become? The only bastion of taste left in this geek dominated world, they too have fallen prey to the easy game.`}</p>
    <p>{`Except Apple has never been good at competing on specs, that's Samsung's territory. Competing on specs is the place where great experiences go to die in a sea of A/B testing, childish competition and poor taste.`}</p>
    <p>{`With Apple gone, where can I turn?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.confused.com/car-insurance/news/aston-martin-no-longer-coolest-make-1917"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_118_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.confused.com/car-insurance/news/aston-martin-no-longer-coolest-make-1917"
        }}>{`Aston Martin no longer coolest make - Confused.com`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hypebeast.com/2012/10/a-beautiful-look-into-james-bonds-aston-martin-db5/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/118452156_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://hypebeast.com/2012/10/a-beautiful-look-into-james-bonds-aston-martin-db5/"
        }}>{`A Beautiful Look Into James Bond's Aston Martin DB5`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.werd.com/17088/2013-aston-martin-db9/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/113119209_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.werd.com/17088/2013-aston-martin-db9/"
        }}>{`2013 Aston Martin DB9`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seekingalpha.com/article/943771-cramer-and-apple?source=feed"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/120785020_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://seekingalpha.com/article/943771-cramer-and-apple?source=feed"
        }}>{`Cramer And Apple`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hothardware.com/News/Samsung-Will-No-Longer-Provide-LCDs-to-Apple/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/120481156_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://hothardware.com/News/Samsung-Will-No-Longer-Provide-LCDs-to-Apple/"
        }}>{`Samsung Will No Longer Provide LCDs to Apple`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/how-will-apple-market-the-ipad-mini-2012-10"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/120655116_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.businessinsider.com/how-will-apple-market-the-ipad-mini-2012-10"
        }}>{`Here's The Big Question Apple Has To Answer About The iPad Mini (AAPL)`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7b009c8c-afdb-4bb5-a0fe-a4ccc4987304",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      